<div class="c-payment-details-breakdown-item">
  <div class="c-payment-details-breakdown-item_titleblock">
    <!--搭乗者姓名-->
    <div class="c-payment-details-breakdown-item_titleblock_title">
      {{ data.dispName }}
    </div>
    <!-- 搭乗者種別 -->
    <div [ngSwitch]="data.ptc" class="c-payment-details-breakdown-item_titleblock_subtitle">
      <span *ngSwitchCase="'ADT'" [innerHTML]="'label.adult' | staticMsg"></span>
      <span *ngSwitchCase="'CHD'" [innerHTML]="'label.child' | staticMsg"></span>
      <span *ngSwitchCase="'INF'" [innerHTML]="'label.infant' | staticMsg"></span>
    </div>
  </div>
  <!--運賃/マイル -->
  <div *ngIf="!isAwardBooking" class="c-payment-details-breakdown-item_items">
    <div class="c-payment-details-breakdown-item_items_title">
      <div [innerHTML]="'label.fare' | staticMsg"></div>
      <div>
        <span
          *ngIf="!isCanada"
          class="not-bold"
          [innerHTML]="data.unitTicketBase | amountFormat : undefined : data.currencyCode"
        ></span>
      </div>
    </div>
  </div>
  <div *ngIf="isAwardBooking" class="c-payment-details-breakdown-item_items">
    <div class="c-payment-details-breakdown-item_items_title">
      <div [innerHTML]="'label.requiredMileage' | staticMsg"></div>
      <div>
        <span class="not-bold" [innerHTML]="paxRequiredMiles | milesFormat : 'currencyUnit.MIL'"></span>
      </div>
    </div>
  </div>
  <!--税金・料金等詳細 -->
  <div class="c-payment-details-breakdown-item_items">
    <div class="c-payment-details-breakdown-item_items_title">
      <div [innerHTML]="'label.totalTax' | staticMsg"></div>
    </div>
    <!-- 各国諸税 -->
    <div *ngFor="let tax of taxesPerCountry" class="c-payment-details-breakdown-item_items_content">
      <div class="c-payment-details-breakdown-item_items_content_title" [innerHTML]="tax.name"></div>
      <div [innerHTML]="tax.value | amountFormat : undefined : data.currencyCode"></div>
    </div>
  </div>
  <!-- 発券手数料 -->
  <div *ngIf="!isCanada" class="c-payment-details-breakdown-item_items">
    <div class="c-payment-details-breakdown-item_items_title">
      <div [innerHTML]="'label.fee' | staticMsg"></div>
      <!-- ※固定値0を出力 -->
      <div>
        <span class="not-bold" [innerHTML]="0 | amountFormat : undefined : data.currencyCode"></span>
      </div>
    </div>
  </div>
</div>
